import withBreakpoints from 'lib/withBreakpoints';
import Navigation from './Navigation';

export default withBreakpoints(Navigation);
